import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/auth` : '/api/auth';

const login = async (email, password) => {
    const response = await axios.post(`${API_URL}/login`, { email, password });
    if (response.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data;
};

const register = async (name, email, password) => {
    const response = await axios.post(`${API_URL}/register`, { name, email, password });
    if (response.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data;
};

const logout = () => {
    localStorage.removeItem('user');
};

const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem('user'));
};

const hasPermission = (section, action) => {
    const user = getCurrentUser();
    if (!user || !user.user) return false;

    // Super Admin has all permissions
    if (user.user.role === 'Admin' || user.user.role === 'admin') return true;

    const permissions = user.user.permissions;
    if (!permissions || !permissions[section]) return false;

    return !!permissions[section][action];
};

const authService = {
    login,
    register,
    logout,
    getCurrentUser,
    hasPermission,
};

export default authService;
